<template>
  <div
    class="border p-2 bg-white rounded-3 agreement-template-select-list-item hover-fade"
    style="max-width: 240px"
    @click.prevent.stop="() => fetchDataAndOpenModal()"
  >
    <div class="d-flex flex-column gap-2">
      <img
        v-if="template.thumbImgUrl"
        :src="template.thumbImgUrl"
        alt="テンプレート画像"
        class="w-100"
      />
      <h5 class="bold mb-0">{{ template.data.title }}</h5>
      <p class="text-muted small mb-0">{{ template.data.short_desc }}</p>
      <div class="d-flex justify-content-center">
        <button
          class="btn btn-outline-primary btn-sm"
          @click.prevent.stop="() => fetchDataAndOpenModal()"
        >
          このテンプレートで送る
        </button>
      </div>
    </div>
  </div>
  <b-modal
    ref="createNewAgreementModal"
    size="md"
    ok-only
    ok-variant="outline-secondary"
    ok-title="キャンセル"
  >
    <template #title>
      <code>{{ templateData.title }}</code> で 送信
    </template>
    <AgreementTemplateQuickCreateNewAgreementForm
      :agreementTemplateId="templateData?.id"
      @submitted="
        () => {
          $refs.createNewAgreementModal.hide()
          $core.$router.push('/pb/同意依頼一覧')
        }
      "
    />
  </b-modal>
</template>

<script lang="ts">
import { PropType } from 'vue'
import AgreementTemplateQuickCreateNewAgreementForm from '../AgreementTemplateQuickCreateNewAgreementFormService/AgreementTemplateQuickCreateNewAgreementForm.vue'
import { AgreementTemplateDTO } from './AgreementTemplateSelectService'
import { ModelPsAgreementTemplate } from '../../models/fireModels/types'

export default {
  name: 'AgreementTemplateSelectListItem',
  components: { AgreementTemplateQuickCreateNewAgreementForm },
  props: {
    template: {
      type: Object as PropType<AgreementTemplateDTO>,
      required: true,
    },
  },
  data() {
    return {
      initialized: false,
      templateData: {} as Partial<ModelPsAgreementTemplate>,
    }
  },
  setup(props) {
    const template = props.template
    return { template }
  },
  methods: {
    async fetchDataAndOpenModal() {
      this.templateData = await $core.$models.ps_agreement_template.findById(this.template.id)
      if(!this.$refs.createNewAgreementModal || !this.templateData) {
        return
      }
      this.$refs.createNewAgreementModal?.show?.()
    },
  },
}
</script>
